// extracted by mini-css-extract-plugin
module.exports = {"showText":"style_showText__1ibyH","rateButton":"style_rateButton__yZsVW"};